<template>
  <div class="container">
    <div class="aside-toggle-btn" @click="totalCollapse">
      <i class="el-icon-s-fold"></i>
    </div>
    <div class="path-wrap">
      <div @click="clickInput">
        <el-input
          prefix-icon="el-icon-search"
          clearable
          @keydown.enter.native="handleSearch"
          @input="searchContent"
          @focus="showContent"
          v-model="input"
          placeholder="学员姓名/班级"
        >
        </el-input>
        <div class="select-info" v-show="showSearchInfo">
          <div v-if="noInfo">
            <!-- 学员 -->
            <div class="select-info-in" v-if="studentList.length > 0">
              <div class="name">学员</div>
              <div class="detailed">
                <div
                  class="hover-name"
                  v-for="item in studentList"
                  :key="item.student_id"
                  @click="goDetail('studyDetails', item.student_id)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <!-- 班级 -->
            <div class="select-info-in" v-if="classList.length > 0">
              <div class="name">班级</div>
              <div class="detailed">
                <div
                  class="hover-name"
                  v-for="item in classList"
                  :key="item.class_id"
                  @click="goDetail('classManageDetail', item.class_id)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <!-- 课程 -->
            <div class="select-info-in" v-if="courseList.length > 0">
              <div class="name">课程</div>
              <div class="detailed">
                <div
                  class="hover-name"
                  v-for="item in courseList"
                  :key="item.course_id"
                  @click="goDetail('storeCourseDetail', item.course_id)"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
            <!-- 员工 -->
            <div class="select-info-in" v-if="staffList.length > 0">
              <div class="name">员工</div>
              <div class="detailed">
                <div
                  class="hover-name"
                  v-for="item in staffList"
                  :key="item.staff_id"
                  @click="goDetail('editEmployee', item.staff_id)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <!-- 菜单 -->
            <div class="select-info-in" v-if="menuList.length > 0">
              <div class="name">菜单</div>
              <div class="detailed">
                <div
                  class="hover-name"
                  v-for="item in menuList"
                  :key="item.length"
                  @click="goDetail(item.route_name)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="!noInfo" class="no-info">暂无内容</div>
        </div>
      </div>
    </div>
    <div class="user-info-wrap">
      <div class="item" @click="toLibrary">
        <p style="cursor: pointer">WOW学院</p>
      </div>
      <div class="item" @click="toggleQRCode1Dialog">
        <p style="cursor: pointer">公众号</p>
      </div>
      <div class="item">
        <a href="./doc.html" target="_blank">使用说明</a>
      </div>
      <div class="item" @click="toggleQRCode2Dialog">
        <p style="cursor: pointer">咨询客服</p>
      </div>
      <div class="item" v-if="userInfo.is_super === 1">
        <span class="super">超管模式</span>
      </div>
      <div class="item" v-if="userInfo.is_super === 1">
        <div class="content" @click="toggleSuperOrgDialog">
          <i class="store iconfont icon-store"></i>
          <p class="text">{{ userInfo.org_name }}</p>
          <i class="arrow el-icon-caret-bottom" v-if="superOrgList.length > 1">
          </i>
        </div>
        <div
          class="pop-wrap-shadow"
          v-if="superOrgDialogVisible"
          @click="toggleSuperOrgDialog"
        ></div>
        <div class="pop-wrap" v-if="superOrgDialogVisible">
          <div class="super-search-wrap">
            <div class="super-search">
              <el-input
                v-model="superSearchOrgValue"
                prefix-icon="el-icon-search"
                placeholder="请输入门店名称"
                @change="handleSuperOrgSearch"
                clearable
              ></el-input>
            </div>
            <div class="super-result">
              <div
                class="super-result-item"
                v-for="org in superSearchOrgResult"
                :key="org.org_id"
                @click="changeOrg(org.org_id)"
              >
                <span class="dot"></span>
                <span class="name">{{ org.org_name }}</span>
                <i class="arrow el-icon-arrow-right"></i>
              </div>
              <div
                v-show="superSearchOrgResult.length === 0"
                style="
                  text-align: center;
                  font-size: 14px;
                  color: #555;
                  margin-top: 12px;
                "
              >
                暂无数据
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item" v-if="userInfo.is_super === 2">
        <div class="content" @click="toggleOrgDialog">
          <i class="store iconfont icon-store"></i>
          <p class="text">{{ userInfo.org_name }}</p>
          <i class="arrow el-icon-caret-bottom" v-if="orgList.length > 0"> </i>
        </div>
        <div
          class="pop-wrap-shadow"
          v-if="orgDialogVisible"
          @click="toggleOrgDialog"
        ></div>
        <div class="pop-wrap" v-if="orgDialogVisible">
          <div>
            <div class="inst" v-for="item in orgList" :key="item.inst_id">
              <p class="inst-head">
                <img
                  src="https://wowsite.musicwow.com/teaching_system_frontend/images/store.png"
                  width="15"
                  height="15"
                />
                {{ item.name }}
              </p>
              <div
                class="inst-org"
                v-for="org in item.org_list"
                :key="org.org_id"
                @click="changeOrg(org.org_id)"
              >
                <span class="org-dot"></span>
                <span class="org-name">{{ org.org_name }}</span>
                <i class="org-arrow el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="content" @click="toggleUserDialog">
          <img
            class="logo"
            :src="userInfo.staff_avatar_url"
            v-if="userInfo.staff_avatar_url"
          />
          <img
            v-else
            class="logo"
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/avatars/owl.png"
          />
          <p class="text">{{ userInfo.staff_name }}</p>
          <i class="arrow el-icon-caret-bottom"></i>
        </div>
        <div
          class="pop-wrap-shadow"
          v-if="userDialogVisible"
          @click="toggleUserDialog"
        ></div>
        <div class="pop-wrap short" v-if="userDialogVisible">
          <div class="logout" @click="logout()">退出登录</div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="qrcode1DialogVisible"
      title="扫码关注公众号"
      width="499px"
      destroy-on-close
    >
      <div class="code-dialog">
        <p class="desp">
          员工（教师），与学员分别扫码关注公众号后，在达到推送条件后，会发布消息给对应用户。
        </p>
        <div class="code-wrap">
          <div class="code-item">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/teacher_qrcode.png"
              width="176"
              height="176"
            />
            <p class="name">员工、教师 公众号</p>
          </div>
          <div class="code-item">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/student_qrcode.png"
              width="176"
              height="176"
            />
            <p class="name">学员 公众号</p>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="qrcode2DialogVisible"
      title="咨询客服"
      width="320px"
      destroy-on-close
    >
      <div class="code-dialog">
        <p class="desp">微信扫一扫，咨询门店系统使用中遇到的问题</p>
        <div class="code-wrap">
          <div class="code-item">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/customer_service_qrcode.png"
              width="176"
              height="176"
            />
            <p class="name">客服二维码</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import { UserModule } from "@/store/module/user";
import { RouterModule } from "@/store/module/router";
import { indexSearchApi } from "@/api/home";
import { getUserInfo, adminOrgListApi } from "@/api/staff";
export default {
  data() {
    return {
      isCollapse: false,
      orgDialogVisible: false,
      userDialogVisible: false,
      qrcode1DialogVisible: false,
      qrcode2DialogVisible: false,
      showSearch: true,
      input: "",
      showSearchInfo: false,
      noInfo: true,
      studentList: [],
      classList: [],
      courseList: [],
      staffList: [],
      menuList: [],
      leftSidebar: {},
      superOrgDialogVisible: false,
      superOrgList: [],
      superSearchOrgValue: "",
      superSearchOrgResult: [], // 超管的门店列表
      currentOperation: false, // 是否在当前页进行退出登录/切换门店等操作
    };
  },
  mounted() {
    const collapseCache = localStorage.getItem("layout-collapse");
    if (collapseCache) {
      this.isCollapse = localStorage.getItem("layout-collapse") === "close";
      eventBus.$emit("collapse", this.isCollapse);
    }
    document.addEventListener("click", () => {
      this.showSearchInfo = false;
    });
    this.leftSidebar = document.getElementById("left-sidebar");
    setTimeout(() => {
      eventBus.$emit("leftSidebar", this.leftSidebar.clientWidth);
    }, 100);
    if (this.userInfo.is_super === 1) {
      adminOrgListApi().then((res) => {
        this.superOrgList = res.data.list;
        this.superSearchOrgResult = res.data.list;
      });
    }
  },
  created() {
    this.changeBreadcrumb(this.matched);
    if (this.$route.query.name) {
      this.input = this.$route.query.name;
    }
    // 监听页面间通讯
    const channel = new BroadcastChannel("mwow-page-channels");
    channel.onmessage = (event) => {
      if (event.data === "user-change-org") {
        if (!this.currentOperation) {
          // 切换门店
          this.$alert(`您已切换门店，当前页面已失效，请返回首页`, `页面失效`, {
            type: "warning",
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled mini",
            iconClass: "mwow-icon-error",
            callback: () => {
              window.location.href = window.location.origin;
            },
          });
        } else {
          this.currentOperation = false;
        }
      }
      if (event.data === "user-new-login") {
        // 用户重新登录
        this.$alert(
          `您已登录其它账户，当前页面已失效，请返回首页`,
          `页面失效`,
          {
            type: "warning",
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled mini",
            iconClass: "mwow-icon-error",
            callback: () => {
              window.location.href = window.location.origin;
            },
          }
        );
      }
      if (event.data === "super-new-login") {
        // 超管重新登录
        this.$alert(
          `您已登录其它超管账户，当前页面已失效，请返回首页`,
          `页面失效`,
          {
            type: "warning",
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled mini",
            iconClass: "mwow-icon-error",
            callback: () => {
              window.location.href = window.location.origin;
            },
          }
        );
      }
      if (event.data === "user-logout") {
        if (!this.currentOperation) {
          // 用户重新登录
          this.$alert(
            `您已退出登录，当前页面已失效，请返回登录页`,
            `页面失效`,
            {
              type: "warning",
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
              callback: () => {
                window.location.href = window.location.origin + "/#/login";
              },
            }
          );
        } else {
          this.currentOperation = false;
        }
      }
    };
  },
  computed: {
    matched() {
      return this.$route.matched;
    },
    userInfo() {
      return UserModule.userInfo;
    },
    orgList() {
      return UserModule.orgList;
    },
  },
  methods: {
    beforeUpdate() {
      this.changeBreadcrumb(this.matched);
    },
    changeBreadcrumb(v) {
      v.map((item) => {
        if (
          item.path == "/layout/home" ||
          item.path == "/layout/search_result"
        ) {
          this.showSearch = false;
        } else {
          this.showSearch = true;
        }
      });
    },
    handleSearch(v) {
      if (this.input) {
        const goSearchResult = this.$router.resolve({
          name: "searchResult",
          query: {
            name: this.input,
          },
        });
        window.open(goSearchResult.href, "_blank");
      }
    },
    searchContent(n) {
      this.classList = [];
      this.menuList = [];
      this.staffList = [];
      this.studentList = [];
      this.courseList = [];
      if (n != "") {
        indexSearchApi({
          page: 1,
          page_size: 3,
          key_word: n,
        }).then((res) => {
          if (res.error_code === 0) {
            if (res.data.class.list.length > 0) {
              this.classList = res.data.class.list;
            }
            if (res.data.menu.list.length > 0) {
              this.menuList = res.data.menu.list;
            }
            if (res.data.staff.list.length > 0) {
              this.staffList = res.data.staff.list;
            }
            if (res.data.student.list.length > 0) {
              this.studentList = res.data.student.list;
            }
            if (res.data.course.list.length > 0) {
              this.courseList = res.data.course.list;
            }
            if (
              res.data.course.total == 0 &&
              res.data.class.total == 0 &&
              res.data.menu.total == 0 &&
              res.data.student.total == 0 &&
              res.data.staff.total == 0
            ) {
              this.noInfo = false;
            } else {
              this.noInfo = true;
            }
          }
        });
      }
      if (this.input) {
        this.showSearchInfo = true;
      } else {
        this.showSearchInfo = false;
      }
    },
    hiddenContent(e) {
      this.showSearchInfo = false;
      e.preventDefault();
      e.stopPropagation();
    },
    clickInput(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    showContent(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.input) {
        this.showSearchInfo = true;
        this.searchContent(this.input);
      }
    },
    goDetail(n, id) {
      this.showSearchInfo = false;
      this.input = "";
      this.$router.push({
        name: n,
        query: {
          id: id,
        },
      });
    },
    totalCollapse() {
      this.isCollapse = !this.isCollapse;
      localStorage.setItem(
        "layout-collapse",
        this.isCollapse ? "close" : "open"
      );
      eventBus.$emit("collapse", this.isCollapse);
      setTimeout(() => {
        eventBus.$emit("leftSidebar", this.leftSidebar.clientWidth);
      }, 100);
    },
    toggleOrgDialog() {
      if (this.orgList.length === 0) {
        return false;
      } else {
        this.orgDialogVisible = !this.orgDialogVisible;
      }
    },
    toggleSuperOrgDialog() {
      if (this.superOrgList.length <= 1) {
        return false;
      } else {
        if (!this.superOrgDialogVisible) {
          this.superSearchOrgValue = "";
          this.superSearchOrgResult = [...this.superOrgList];
        }
        this.superOrgDialogVisible = !this.superOrgDialogVisible;
      }
    },
    handleSuperOrgSearch(v) {
      adminOrgListApi({
        org_name: v || "",
      }).then((res) => {
        this.superSearchOrgResult = res.data.list;
      });
    },
    toggleUserDialog() {
      this.userDialogVisible = !this.userDialogVisible;
    },
    toggleQRCode1Dialog() {
      this.qrcode1DialogVisible = !this.qrcode1DialogVisible;
    },
    toggleQRCode2Dialog() {
      this.qrcode2DialogVisible = !this.qrcode2DialogVisible;
    },
    toLibrary() {
      getUserInfo().then((res) => {
        if (res.error_code === 0) {
          if (res.data.org.source_material === 1) {
            this.$router.push({
              name: "materialLibrary",
            });
          } else {
            this.$message({
              type: "error",
              message: "暂无查看权限",
            });
            return;
          }
        }
      });
    },
    changeOrg(id) {
      if (id == this.userInfo.org_id) {
        this.$message({
          type: "warning",
          message: "当前已在该门店",
        });
        return false;
      }
      this.currentOperation = true;
      this.$nextTick(() => {
        RouterModule.CLEAR_ROUTER();
        UserModule.changeOrgLogin(id);
        this.toggleOrgDialog();
      });
    },
    logout() {
      this.userDialogVisible = false;
      this.$confirm("确定退出登录？", `退出登录`, {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      })
        .then(() => {
          this.currentOperation = true;
          this.$nextTick(() => {
            UserModule.LoginOut();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  height: 100%;
  .aside-toggle-btn {
    padding: 8px;
    margin-left: 11px;
    cursor: pointer;
    i {
      font-size: 12px;
      line-height: 12px;
    }
  }
  .path-wrap {
    flex: 1;
    margin: 0 13px;
    span,
    i {
      display: inline-block;
      font-size: 12px;
      line-height: 13px;
      color: #606063;
      margin-right: 16px;
    }
  }
  .user-info-wrap {
    display: flex;
    .item {
      margin-right: 20px;
      position: relative;
      display: flex;
      align-items: center;
      color: #606063;
      font-size: 12px;
      a {
        color: #606063;
      }
      .content {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .super {
        background: #fdf0f0;
        color: #f56c6c;
        line-height: 18px;
        font-size: 12px;
        padding: 0 7px;
        border-radius: 4px;
      }
      .store {
        font-size: 15px;
        width: 14px;
        height: 14px;
        margin-right: 9px;
        margin-top: -4px;
      }
      .logo {
        width: 23px;
        height: 23px;
        border-radius: 50%;
        margin-right: 9px;
        border: 1px solid #eef3f6;
      }
      .text {
        font-size: 12px;
        line-height: 13px;
        color: #606063;
      }
      .arrow {
        padding: 11px;
        cursor: pointer;
      }
    }
    .pop-wrap-shadow {
      z-index: 1000;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    .pop-wrap {
      z-index: 1001;
      color: #5c5d5e;
      position: absolute;
      top: 42px;
      right: -20px;
      width: 330px;
      max-height: 484px;
      overflow: hidden auto;
      padding: 24px 36px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0px 0px 10px rgba(203, 203, 203, 0.5);
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 4px;
        background: none;
      }
      &::-webkit-scrollbar-thumb {
        width: 4px;
        background: #d8d8d8;
      }
      &::-webkit-scrollbar-button {
      }
      &.short {
        width: auto;
        padding: 0;
      }
      .inst {
        border-bottom: 1px solid #e7e8ea;
        padding-bottom: 20px;
        margin-bottom: 20px;
        &:last-child {
          border-bottom: 0;
          padding-bottom: 0;
          margin-bottom: 0;
        }
        .inst-head {
          line-height: 16px;
          color: #5c5d5e;
          font-size: 16px;
          margin-bottom: 18px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-weight: bold;
          img {
            margin-right: 10px;
            margin-top: 0;
            vertical-align: top;
          }
        }
        .inst-org {
          display: flex;
          font-size: 14px;
          line-height: 30px;
          height: 30px;
          padding: 0 12px;
          align-items: center;
          cursor: pointer;
          border-radius: 4px;
          background: #f8fafb;
          margin-bottom: 12px;
          color: #5c5d5e;
          &:last-child {
            margin-bottom: 0;
          }
          &:hover {
            span {
              color: #4fb77c;
            }
          }
          .org-dot {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: #d8d8d8;
            margin-right: 9px;
          }
          .org-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &:nth-child(1) {
              flex: 5;
            }
            &:nth-child(2) {
              flex: 2;
            }
            &:nth-child(3) {
              flex: 3;
            }
          }
          .org-icon {
          }
        }
      }
      .super-search-wrap {
        position: relative;
        max-height: 452px;
        display: flex;
        flex-direction: column;
        .super-search {
          margin-bottom: 12px;
          /deep/ .el-input {
            width: 100% !important;
            .el-input__inner {
              width: 100% !important;
            }
          }
        }
        .super-result {
          flex: 1;
          overflow: hidden auto;
          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-track {
            width: 4px;
            background: none;
          }
          &::-webkit-scrollbar-thumb {
            width: 4px;
            background: #d8d8d8;
          }
          &::-webkit-scrollbar-button {
          }
          .super-result-item {
            display: flex;
            background-color: #f8fafb;
            margin-bottom: 12px;
            align-items: center;
            padding-left: 16px;
            height: 30px;
            line-height: 30px;
            border-radius: 4px;
            cursor: pointer;
            &:hover {
              .name {
                color: #4fb77c;
              }
            }
            .dot {
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background-color: #d8d8d8;
              margin-right: 9px;
            }
            .name {
              flex: 1;
              font-size: 14px;
              color: #5c5d5e;
            }
            .arrow {
            }
          }
        }
      }
      .logout {
        cursor: pointer;
        color: #5c5d5e;
        font-size: 14px;
        text-align: center;
        line-height: 14px;
        padding: 12px 18px;
        white-space: nowrap;
        &:hover {
          color: #4fb77c;
        }
      }
    }
  }
}
.code-dialog {
  .desp {
    font-size: 14px;
    color: #ffb940;
    line-height: 20px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .code-wrap {
    text-align: center;
    .code-item {
      display: inline-block;
      vertical-align: top;
      margin: 0 22px;
      .name {
        font-size: 14px;
        line-height: 18px;
        color: #5c5d5e;
        margin: 17px 0 6px 0;
        font-weight: bold;
      }
    }
  }
}
.select-info {
  min-width: 192px;
  min-height: 170px;
  z-index: 2022;
  background: #ffffff;
  position: fixed;
  border-radius: 4px;
  margin-top: 7px;
  box-shadow: 0px 0px 5px 0px rgba(203, 203, 203, 0.5);
  .select-info-in {
    border-bottom: 1px solid #e6e7e9;
    display: flex;
    &:last-child {
      border-bottom: none;
    }
    .name {
      padding-top: 13px;
      width: 50px;
      font-size: 12px;
      text-align: center;
      font-weight: 400;
    }
    .detailed {
      flex: 1;
      padding: 8px 0;
      div {
        padding: 0 12px;
        text-align: left;
        line-height: 23px;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}
.no-info {
  font-size: 12px;
  color: #c2c3c4;
  margin: 12px 0 0 13px;
}
/deep/ .el-input {
  width: 192px;
  height: 28px;
  .el-input__inner {
    width: 192px;
    height: 28px;
  }
  .el-input__suffix {
    margin-top: -5px;
  }
}
/deep/ .el-input__prefix {
  margin-top: -5px;
}
/deep/ .el-input__inner:focus {
  border-color: #07d1aa !important;
}
.hover-name:hover {
  color: #07d1aa;
  background-color: #f5f7fa;
  border-radius: 5px;
}
</style>
